import { render, staticRenderFns } from "./guesslike.vue?vue&type=template&id=40c6723c&scoped=true&"
import script from "./guesslike.vue?vue&type=script&lang=js&"
export * from "./guesslike.vue?vue&type=script&lang=js&"
import style0 from "./guesslike.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./guesslike.vue?vue&type=style&index=1&id=40c6723c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6723c",
  null
  
)

export default component.exports